import { Container, Grid, Typography, Box, Tooltip } from "@mui/material";
import React from "react";
import { Navigate, NavLink, Route, Routes } from "react-router-dom";
import classes from "../Styles/about.module.css";
import CodeIcon from "@mui/icons-material/Code";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import VideogameAssetIcon from "@mui/icons-material/VideogameAsset";
import PersonalInformation from "../Components/PersonalInformation";
import CloseIcon from "@mui/icons-material/Close";
import Info from "../Components/Info";
import ProfessionalInfo from "../Components/ProfessionalInfo";
import Hobbies from "../Components/Hobbies";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import html from "../Assets/html.jpg";
import javascript from "../Assets/javascript.jpg";
import jquery from "../Assets/jquery.jpg";
import js from "../Assets/js.png";
const AboutMe = () => {
  return (
    <>
      <Container disableGutters maxWidth="100vw" className={classes.about_body}>
        <Grid container className={classes.grid_container}>
          <Grid
            item
            xs={12}
            sx={{
              display: { xs: "block", md: "none" },
              pl: { xs: 3, md: 0 },
              pb: { xs: 3, md: 0 },
              pt: 3,
              textAlign: "center",
            }}
          >
            <Typography className={classes.about_text}>_about-me</Typography>
          </Grid>
          <Grid
            item
            className={classes.grid_item}
            sx={{ display: { xs: "none", md: "block" } }}
            md={0.6}
          >
            <NavLink
              style={({ isActive }) =>
                isActive ? { color: "#81A1C1" } : { color: "#607B96" }
              }
              to={`/aboutme/professional-information`}
            >
              <Tooltip title="proffesional-info" placement="right-start">
                <Typography sx={{ pb: 2 }}>
                  <CodeIcon />
                </Typography>
              </Tooltip>
            </NavLink>
            <NavLink
              style={({ isActive }) =>
                isActive ? { color: "#81A1C1" } : { color: "#607B96" }
              }
              to={`/aboutme/personal-information`}
            >
              <Tooltip title="personal-info" placement="right-start">
                <Typography sx={{ pb: 2 }}>
                  <LightbulbIcon />
                </Typography>
              </Tooltip>
            </NavLink>
            <NavLink
              style={({ isActive }) =>
                isActive ? { color: "#81A1C1" } : { color: "#607B96" }
              }
              to={`/aboutme/hobbies`}
            >
              <Tooltip title="hobbies" placement="right-start">
                <Typography sx={{ pb: 2 }}>
                  <VideogameAssetIcon />
                </Typography>
              </Tooltip>
            </NavLink>
          </Grid>

          <Routes>
            <Route
              exact
              path="/"
              element={<Navigate to="/aboutme/professional-information" />}
            />
            <Route
              exact
              path="personal-information"
              element={<PersonalInformation />}
            />
            <Route
              exact
              path="professional-information"
              element={<ProfessionalInfo />}
            />
            <Route exact path="hobbies" element={<Hobbies />} />
          </Routes>
          <Grid
            item
            md={5}
            sx={{ borderRight: { xs: "none", md: "0.25px solid #1E2D3D" } }}
          >
            <Box
              sx={{
                overflowY: { xs: "visible", md: "scroll" },
                height: "100%",
              }}
              className={classes.about_overflow}
            >
              <Box
                sx={{
                  borderBottom: { xs: "none", md: "0.25px solid #1E2D3D" },
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <Typography
                    sx={{
                      color: "#607B96",
                      borderRight: "0.25px solid #1E2D3D",
                      fontSize: "16px",
                      display: { xs: "none", md: "block" },
                      fontFamily: "'Fira Code', monospace !important",
                      pt: 1.4,
                      pb: 1,
                      pl: 2,
                    }}
                  >
                    personal-info
                    <CloseIcon
                      sx={{ fontSize: "18px", pt: 0.4, pl: 4, pr: 2 }}
                    />
                  </Typography>
                  <Typography
                    sx={{
                      color: "#FFFFFF",

                      fontSize: "16px",
                      display: { xs: "block", md: "none" },
                      fontFamily: "'Fira Code', monospace !important",
                      pt: 5,
                      pb: 1,
                      pl: 2,
                    }}
                  >
                    {`// personal-info`}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: { xs: "none", md: "block" }, p: 2 }}>
                <Info text={" /**"} number={1} />
                <Info text={"  * About Me"} number={2} />
                <Info
                  text={
                    " * Hi, I’m Oyelola — a Full Stack Software Engineer with 5 years of experience"
                  }
                  number={3}
                />
                <Info
                  text={
                    " * building scalable, secure, and high performance web applications"
                  }
                  number={4}
                />
                <Info
                  text={" * that people actually use in production."}
                  number={5}
                />
                <Info
                  text={
                    " * I spend most of my time in the JavaScript/TypeScript ecosystem,"
                  }
                  number={6}
                />
                <Info
                  text={
                    " * working across frontend, backend services, and cloud deployments."
                  }
                  number={7}
                />
                <Info
                  text={
                    " * I like turning slow, messy systems into fast, reliable products"
                  }
                  number={8}
                />
                <Info
                  text={
                    " * through practical architecture choices and performance optimization."
                  }
                  number={9}
                />
                <Info
                  text={
                    " * I enjoy collaborating with product and engineering teams to ship useful features."
                  }
                  number={10}
                />
                <Info text={" * Core stack highlights:"} number={11} />
                <Info
                  text={
                    " * React, Next.js, TypeScript, Node.js (Express/NestJS),"
                  }
                  number={12}
                />
                <Info
                  text={
                    " * PostgreSQL, MongoDB, Redis, Docker, Kubernetes, AWS, CI/CD."
                  }
                  number={13}
                />
                <Info text={" **/"} number={14} />
              </Box>
              <Box sx={{ display: { xs: "block", md: "none" }, pt: 4, pb: 5 }}>
                <Typography className={classes.about_info_small}>
                  Hi, I’m Oyelola Adeboye Samuel — a Full Stack Software
                  Engineer with 5 years of experience building scalable, secure,
                  high performance web applications used in real production
                  environments. I work mostly with JavaScript/TypeScript across
                  frontend, backend services, and cloud deployments, and I enjoy
                  improving speed, reliability, and developer experience through
                  clean architecture and performance optimization.
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={4}>
            <Typography
              sx={{
                color: "#FFFFFF",

                fontSize: "16px",

                fontFamily: "'Fira Code', monospace !important",
                pt: 2,
                pb: 1,
                pl: 2,
              }}
            >
              {`// Certifications`}
            </Typography>
            <Box
              sx={{
                width: "100%",
                mt: 10,
              }}
            >
              <Carousel
                autoPlay={true}
                centerSlidePercentage={20}
                infiniteLoop={true}
                interval={3000}
                stopOnHover={true}
                swipeable={true}
                width="100%"
                transitionTime={2000}
                showIndicators={false}
                showThumbs={false}
              >
                <div>
                  <img
                    style={{ width: "100%", height: "300px" }}
                    src={html}
                    alt="certificate"
                  />
                </div>
                <div>
                  <img
                    style={{ width: "100%", height: "300px" }}
                    src={js}
                    alt="certificate"
                  />
                </div>
                <div>
                  <img
                    style={{ width: "100%", height: "300px" }}
                    src={jquery}
                    alt="certificate"
                  />
                </div>
                <div>
                  <img
                    style={{ width: "100%", height: "300px" }}
                    src={javascript}
                    alt="certificate"
                  />
                </div>
              </Carousel>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default AboutMe;
